export default "__VITE_ASSET__a6fb810c__"